<template>
  <div
    class="concepts-search"
    v-click-outside="() => (resultsDismissed = true)"
  >
    <div class="results" v-if="showResults">
      <template v-if="results && results.length">
        <div
          class="result"
          v-for="concept in results"
          :key="concept.id"
          @click="() => onClick(concept)"
        >
          {{ concept.label }}
        </div>
      </template>
      <div v-else class="no-results">Nothing found</div>
    </div>
    <div class="input-box">
      <input
        class="search-input"
        v-model="search"
        :placeholder="t('find_concept')"
        @focus="resultsDismissed = false"
      />
      <div
        class="icon"
        :class="search ? 'close' : 'search'"
        @click="search = null"
      ></div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  props: {
    concepts: { type: Array, required: true },
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      search: null,
      resultsDismissed: false,
    };
  },
  computed: {
    results() {
      return this.search
        ? this.concepts.filter(
            (concept) =>
              concept.label.toLowerCase().indexOf(this.search.toLowerCase()) >
              -1
          )
        : [];
    },
    showResults() {
      return this.search && !this.resultsDismissed;
    },
  },
  methods: {
    onClick(concept) {
      this.$emit("select", concept);
      this.resultsDismissed = true;
    },
  },
  watch: {
    search() {
      this.resultsDismissed = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.concepts-search
  display: none

  .input-box
    background-color: #fff
    border: 1px solid $golden
    border-radius: 2px
    display: flex
    padding: vw(10px) vw(20px)
    position: relative

    .search-input
      border: none
      outline: none

    .icon
      cursor: pointer

      &.search
        m-icon("search", 28)

      &.close
        m-icon("close", 20)

  .results
    background-color: #fff
    border: 1px solid $golden
    border-radius: 2px
    max-height: 50vh
    overflow-y: auto
    padding: vw(10px)
    position: absolute
    top: "calc(100% + %s)" % vw(10px)
    width: 100%

    .result
      cursor: pointer

      &:not(:last-child)
        margin-bottom: vw(5px)
</style>